/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Open_DetailInputs */

const cs_templates_open_detail = /** @type {(inputs: Templates_Open_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detail a náhled`)
};

const en_templates_open_detail = /** @type {(inputs: Templates_Open_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detail & preview`)
};

/**
* | output |
* | --- |
* | "Detail & preview" |
*
* @param {Templates_Open_DetailInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_open_detail = /** @type {((inputs?: Templates_Open_DetailInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Open_DetailInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_open_detail(inputs)
	return cs_templates_open_detail(inputs)
});